import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {CommonSlickgridComponent} from '../common-slickgrid/common-slickgrid.component';
import {CustomInputEditor} from '../custom-inputEditor';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {RestApiService} from '../rest-api.service';
import {Formatters} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';
@Component({
    selector: 'app-url-mapping',
    templateUrl: './url-mapping.component.html',
    styleUrls: ['./url-mapping.component.css']
})
export class UrlMappingComponent implements OnInit, OnDestroy {

    displayed = true;
    sDate: string;
    eDate: string;
    totalData = 0;
    show: boolean;
    selected: number;
    clientSelected: number;
    clients: any;
    moduleSelected: number;
    modules: any;
    urls: any;
    urlSelected: number;
    url: string;
    urlKey: string;
    urlDesc: string;

    private respObject: any;
    displayData: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    private radioChecked: any;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private adminAuth: Subscription;
    private baseFlag: any;
    clientId: number;
    dataLoaded:boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    keySelected: any;
    keyUrls: any;
    urlName: string;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;

    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {

        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {

                    }
                    break;
                case 'delete':
                    console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteUrlUserWise({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.messageService.setGridWidth(1000);
        this.displayData = {
            pageName: 'Maintain Map Url',
            openModalButton: 'Map Url',
            searchModalButton: 'Search',
            breadcrumb: 'MapUrl',
            folderName: 'All Mapped URL',
            tabName: 'Mapped URL',
            exportBtn: 'Export to excel'

        };

        const columnDefinitions = [{
            id: 'delete',
            field: 'id',
            excludeFromHeaderMenu: true,
            formatter: Formatters.deleteIcon,
            minWidth: 30,
            maxWidth: 30,
        },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'name', name: 'Module Name', field: 'module', sortable: true, filterable: true
            },
            {
                id: 'client', name: 'Client Name', field: 'client', sortable: true, filterable: true
            },
            {
                id: 'url', name: 'URL', field: 'url', sortable: true, filterable: true
            },
            {
                id: 'urlKey', name: 'URL Key', field: 'urlKey', sortable: true, filterable: true
            },
            {
                id: 'urlDesc', name: 'URL Description', field: 'urlDesc', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        this._rest.getClient().subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                this.clients = this.respObject.clients;
                this.clientSelected = 0;
            } else {

            }
        }, function (err) {

        });

        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
    }

    onPageLoad() {
        this.getTableData();
    }


    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllModulePageUrlMapping(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;

                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.moduleSelected = 0;
            this.clientSelected = 0;
            this.isError = false;
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
        }
    }


    searchModal(){
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            
            this.keySelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        }
    }


    search() {
        this._rest.searchAllModulePageUrlMappingStupa( this.keySelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.keyUrls = this.respObject.details;
                this.messageService.setTotalData(this.keyUrls.length);
                this.messageService.setGridData(this.keyUrls);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        // const data = {
        //   module: this.moduleSelected, client: this.clientSelected
        // };
        if (this.radioChecked === 1) {
            const data = {
                clientId: this.clientSelected,
                url: this.url,
                urlDesc: this.urlDesc,
                moduleId: this.moduleSelected,
                urlKey: this.urlKey,
                type: 'update',
                oldUrl: this.urlSelected,
                createbyid: this.messageService.getUserId()
            };

            if (!this.messageService.isBlankField(data)) {
                this._rest.addUrl(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.nextOffset = 0;
                        this.page_no = 0;
                        this.getTableData();
                        // const id = this.respObject.urlId;
                        //  this.messageService.setRow({id: id, url: this.url, urlDesc: this.urlDesc, module: this.moduleName, urlKey: this.urlKey});
                        this.urlDesc = '';
                        this.urlKey = '';
                        this.url = '';
                        this.moduleSelected = 0;
                        this.clientSelected = 0;
                        this.urlSelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = err;
                });
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
            }
        }
        if (this.radioChecked === 2) {
            const data = {
                clientId: this.clientSelected,
                urlId: this.urlSelected,
                moduleId: this.moduleSelected,
                createbyid: this.messageService.getUserId()
            };

            if (!this.messageService.isBlankField(data)) {
                this._rest.mapNewUrlToModule(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.getTableData();
                        // const id = this.respObject.urlId;
                        //  this.messageService.setRow({id: id, url: this.url, urlDesc: this.urlDesc, module: this.moduleName, urlKey: this.urlKey});
                        this.urlDesc = '';
                        this.urlKey = '';
                        this.url = '';
                        this.moduleSelected = 0;
                        this.clientSelected = 0;
                        this.urlSelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = err;
                });
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
            }
        }
    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getMappedURL(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, function (err) {
            console.log(err);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.urls.totalData[0].count;
                this.totalPage = respObject.urls.totalPage;
            }
            if (!this.isEmpty(respObject.urls.dataObj)) {
                const data = respObject.urls.dataObj;
                this.nextOffset = respObject.urls.nextOffset;
                this.previousOffset = respObject.urls.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.urls.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.urls.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }


    onClientChange(value: any) {
        this.urls = [];
        this._rest.getModulesByClientId(value).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.modules.unshift({id: 0, name: 'Select Module'});
                this.modules = this.respObject.modules;
                this.moduleSelected = 0;
            } else {

            }
        }, function (err) {

        });
    }

    onModuleChange(value: any) {
        this.urls = [];
        this.getUrls();
    }

    onUrlChange(value: any) {
        console.log(value);
        this.url = this.urls[value].url;
        this.urlKey = this.urls[value].urlKey;
        this.urlDesc = this.urls[value].urlDesc;
    }

    onRadioButtonChange(selectedValue) {
        this.radioChecked = selectedValue.value;
        this.getUrls();
    }

    getUrls() {
        this.urlDesc = '';
        this.url = '';

        if (this.moduleSelected > 0 && this.clientSelected > 0) {
            if (this.radioChecked === 1) {
                this._rest.getDistinctUrlKey(this.moduleSelected, this.messageService.getUserId(), this.clientSelected).subscribe((res) => {
                    // this._rest.getModuleUrl(this.moduleSelected, this.clientSelected).subscribe((res) => {
                    this.respObject = res;
                    this.urls = [];
                    if (this.respObject.success) {
                        this.isError = false;
                        this.respObject.details.unshift({id: 0, urlKey: 'Select Url Key'});
                        // console.log(JSON.stringify(this.urls));
                        this.urls = this.respObject.details;
                        this.urlSelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, function (err) {

                });
            }
            if (this.radioChecked === 2) {
                this._rest.getRemainingUrlDtls(this.clientSelected, this.moduleSelected).subscribe((res) => {
                    this.respObject = res;
                    // console.log(JSON.stringify(this.respObject));
                    this.urls = [];
                    if (this.respObject.success) {
                        this.isError = false;
                        this.respObject.details.unshift({id: 0, urlKey: 'Select Url Key'});
                        this.urls = this.respObject.details;
                        this.urlSelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, function (err) {

                });
            }
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
